// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__Yqlzt","left":"PageHeader_left__QYWc-","right":"PageHeader_right__bZHVL","button":"PageHeader_button__Q1Eic"};